import { useState } from "react";
import { Button, UncontrolledPopover, PopoverBody } from "reactstrap";
import SelectBox from "components/elements/selectBox";

export const xffbbCategoryOptions = [
    { value: 1, label: "Clothing & Shoes" },
    { value: 2, label: "Beauty & Accessories" },
    { value: 3, label: "Books & Media" },
    { value: 4, label: "Computer & Electronics" },
    { value: 5, label: "Home & Living" },
    { value: 6, label: "Tools & Toys" },
    { value: 7, label: "Health & Foods" },
    { value: 8, label: "Industry & Techs" },
];

const initFilter = {
    min_price: "",
    max_price: "",
    min_stock: "",
    max_stock: "",
    category_id: [],
    warehouse_ids: [],
};

const ProductFilter = ({ setQueryFilter, warehouseOptions = [] }) => {
    const [filter, setFilter] = useState(initFilter);

    const handleChangeFilter = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    return (
        <>
            <Button id="filter-prod" type="button" className="btn btn-light h-100">
                Filter
            </Button>
            <UncontrolledPopover
                placement="bottom"
                target="filter-prod"
                trigger="legacy"
                className="custom-popover-width"
            >
                <PopoverBody>
                    <div>
                        <label className="form-label fw-bold">Price</label>
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Min price"
                                name="min_price"
                                value={filter?.min_price || ""}
                                onChange={handleChangeFilter}
                            />
                            <span className="input-group-text">-</span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Max price"
                                name="max_price"
                                value={filter?.max_price || ""}
                                onChange={handleChangeFilter}
                            />
                        </div>
                    </div>
                    <div className="mt-2">
                        <label className="form-label fw-bold">Stock</label>
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Min stock"
                                name="min_stock"
                                value={filter?.min_stock || ""}
                                onChange={handleChangeFilter}
                            />
                            <span className="input-group-text">-</span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Max stock"
                                name="max_stock"
                                value={filter?.max_stock || ""}
                                onChange={handleChangeFilter}
                            />
                        </div>
                    </div>
                    <SelectBox
                        options={xffbbCategoryOptions}
                        name="category_id"
                        value={filter?.category_id}
                        isMulti
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                category_id: data.value,
                            }));
                        }}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container mt-2"
                        placeholder="Select categories ..."
                    />
                    <SelectBox
                        options={warehouseOptions}
                        name="warehouse_ids"
                        value={filter?.warehouse_ids}
                        isMulti
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                warehouse_ids: data.value,
                            }));
                        }}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container mt-2"
                        placeholder="Select warehouses ..."
                    />
                    <div className="mt-8 d-flex justify-content-end gap-2">
                        <button className="btn btn-white" onClick={() => setFilter(initFilter)}>
                            Reset
                        </button>
                        <button className="btn btn-info" onClick={() => setQueryFilter?.(filter)}>
                            Filter
                        </button>
                    </div>
                </PopoverBody>
            </UncontrolledPopover>
        </>
    );
};

export default ProductFilter;
